<template>
  <div :class="'settings_switch_control' + (disableToggle ? ' settings_switch_control_disabled' : '')">
    <div
      class="settings_switch_button"
      :class="{ enabled: isEnabled }"
      @click.stop.prevent="toggle"
    >
      <div class="button" />
    </div>
  </div>
</template>

<script>
import { component } from '../../../../mixins/component';

export default {
  components: {},
  mixins: [component],
  model: {
    prop: 'isEnabled',
    event: 'toggle',
  },
  props: {
    disableToggle: {
      type: Boolean,
      default: false,
    },
    isEnabled: {
      type: Number,
      required: false,
      default: 0,
    },
    color: {
      type: String,
      required: false,
      default: '#4D4D4D',
    },
  },
  data() {
    return {};
  },
  created() {},
  beforeDestroy() {},
  methods: {
    toggle: function() {
      this.isEnabled = (this.isEnabled === 0) ? 1 : 0;
      this.$emit('toggle', this.isEnabled);
    },
  },
};
</script>

<style scoped>
/* settings switch button */
.settings_switch_control {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0 10px;
}
.settings_switch_control_disabled {
  pointer-events: none;
}

.settings_switch_button {
    position: relative;
    width: 22px;
    height: 14px;
    background-color: var(--profile-switch-button-background-color);
    border-radius: 14px;
    transition: all 0.3s ease-in-out;
    cursor: pointer;
}
.settings_switch_control_disabled .settings_switch_button {
  background-color: #808080FF;
}
.settings_switch_button .button {
    position: absolute;
    top: 2px;
    left: 2px;
    height: 10px;
    width: 10px;
    border-radius: 10px;
    transition: all 0.3s ease-in-out;
    background-color: var(--profile-switch-button-color);
    transform: translate(8px, 0);
}
.settings_switch_button.enabled .button {
    background-color: #EE733A;
    transform: translate(0, 0)
}
.settings_switch_control_disabled .settings_switch_button .button {
  background-color: #FFFFFF !important;
}
.settings_switch_container {
    display: flex;
    background-color: var(--bg-color-primary);
    width: 100%;
    padding: 10px;
    margin-bottom: 10px;
}
.settings_switch_status_controller {
    display: flex;
    align-items: center;
}
.settings_switch_description {
    flex: 1;
    font-size: 14px;
    font-weight: bold;
    color: var(--profile-public-data-label-color);
    margin-right: 10px;
}
.settings_switch_status {
    color: #96999d;
    font-size: 12px;
    font-weight: bold;
}
/* end of settings switch button */
</style>
